export interface ConfirmDialogDetailField {
    label: string;
    value: string;
}

function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function buildConfirmDialogMessageWithDetails(message: string, fields: ConfirmDialogDetailField[]): string {
    const fieldsHtml = fields
        .map(
            field => `
        <div class="dx-dialog-detail-field">
            <div class="dx-dialog-detail-field__label">${escapeHtml(field.label)}</div>
            <div class="dx-dialog-detail-field__value">${escapeHtml(field.value)}</div>
        </div>`
        )
        .join('');

    return `<p class="dx-dialog-message-intro">${escapeHtml(message)}</p><div class="dx-dialog-details">${fieldsHtml}</div>`;
}

export function buildConfirmDialogTitleWithIcon(title: string, iconClass: string): HTMLElement {
    const container = document.createElement('div');
    container.className = 'dx-dialog-header-with-icon';

    const icon = document.createElement('span');
    icon.className = `${iconClass} dx-dialog-header-icon`;
    icon.setAttribute('aria-hidden', 'true');

    const text = document.createElement('span');
    text.className = 'dx-dialog-header-text';
    text.textContent = title;

    container.append(icon, text);
    return container;
}
